import { ApplicationConfig } from '@angular/core';
import {
    provideRouter,
    withEnabledBlockingInitialNavigation,
    withInMemoryScrolling,
    withPreloading,
    withRouterConfig
} from '@angular/router';

import routes from './app-routes';
import { AppConfig } from './config/app.config';
import { StaticText } from './config/static.text';
import { PreloadingStrategyService } from '@app/core/services/preloading-strategy.service';
import { baseAppConfig } from 'src/base-app.config';

export const appConfig: ApplicationConfig = {
    providers: [
        ...baseAppConfig.providers,
        { provide: 'app-config', useValue: { ...AppConfig, static_text: StaticText } },
        provideRouter(
            routes,
            withInMemoryScrolling({
                scrollPositionRestoration: 'enabled'
            }),
            withPreloading(PreloadingStrategyService),
            withRouterConfig({
                paramsInheritanceStrategy: 'always'
            }),
            withEnabledBlockingInitialNavigation()
        )
    ]
};
